import { Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { BalanceEntry, BalanceFilterInput } from 'app/api/balance.api.service';
import { BalanceActionTypes, BalanceLoaded, BalanceRequested, BalanceCancelled } from './balance.actions';
import { KeyStringFilterInput } from 'app/api/common.api.types';
import { LoadingState, CallState } from 'app/utils/callstate';

// tslint:disable-next-line: no-empty-interface
export interface BalanceState extends EntityState<BalanceEntry> {
  companyId: string;
  key?: KeyStringFilterInput;
  filter?: BalanceFilterInput;
  callState: CallState;
}

export const adapter: EntityAdapter<BalanceEntry> = createEntityAdapter<BalanceEntry>({
  selectId: entry => entry.key
});
export const initialBalanceState: BalanceState = adapter.getInitialState({
  companyId: undefined,
  key: undefined,
  filter: undefined,
  callState: LoadingState.Init,
});

export function reducer(state = initialBalanceState, action: Action): BalanceState {
  switch (action.type) {
    case BalanceActionTypes.BalanceRequested:
      const {companyId, key, filter} = (action as BalanceRequested).payload;
      return {
        ...state,
        companyId,
        key,
        filter,
        callState: LoadingState.Loading
      };
    case BalanceActionTypes.BalanceLoaded:
        adapter.removeAll(state);
        return adapter.addAll((action as BalanceLoaded).payload.balance,
        {
          ...state,
          callState: LoadingState.Loaded
        });
    case BalanceActionTypes.BalanceCancelled:
        return {
          ...state,
          callState: { errorMessage: (action as BalanceCancelled).payload.errorMessage }
        };
    default:
      return state;
  }
}

export const {
  selectAll,
  selectEntities,
  selectIds,
  selectTotal
} = adapter.getSelectors();
